//src/command/utils/sembols.js
import { Rectangle, Line, Text } from "./utils";


const layers = {
  0: { name: '0', frozen: false, visible: true, colorIndex: 7, color: 16777215 },
  kirmizi: { name: '18', frozen: false, visible: true, colorIndex: 1, color: 16711680 },
  yesil: { name: 'test', frozen: false, visible: true, colorIndex: 1, color: 65280 },
  mavi: { name: 'test', frozen: false, visible: true, colorIndex: 1, color: 255 },
  sari: { name: 'test', frozen: false, visible: true, colorIndex: 1, color: 16776960 },
  magenta: { name: 'test', frozen: false, visible: true, colorIndex: 1, color: 16711935 },
  cyan: { name: 'test', frozen: false, visible: true, colorIndex: 1, color: 65535 },
  gray: { name: 'test', frozen: false, visible: true, colorIndex: 8, color: 12632256 },
  AKSYAZI: { name: 'AKSYAZI', frozen: false, visible: true, colorIndex: 9, color: 12632256 }
};
const kirmizi = layers.kirmizi
const mavi = layers.mavi
const yesil = layers.yesil
const gray = layers.gray

const op_gray = {
  color: gray.color,
  colorIndex: gray.colorIndex,
  layer: gray.name,
  // lineType:layer.lineType,
  shape: true,
  hasContinuousLinetypePattern: false
}
const op_yesil = {
  color: yesil.color,
  colorIndex: yesil.colorIndex,
  layer: gray.name,
  // lineType:layer.lineType,
  shape: true,
  hasContinuousLinetypePattern: false
}
const Scl = 0.5// 0.75
const rowHeight = 50 * Scl

export const createYuklemeCetvel = (X, Y, W, H, data) => {
    let k = 0 // bu sabit en alttaki summer kısmının yüksekliğpini ayarlamada kullanılıyor.
 
  // ✅ SIMPLE SUPPLY POINT SAFE DESTRUCTURING
  const panels = data?.panels || [];
  const ycItems = Array.isArray(data) ? data : []; // Handle transformed YC data array

  let adpNode = data?.adp
  let result = []

  const headerOption = op_gray
  const tableOption = op_gray
  const gap = 10 * Scl
  let heightOfAllTables = gap
  let headerHeight = 260 * Scl
  const metersCount = 1 // sp.nodes.filter(node => node.type === "Meter").length

  let yukCetWidth = 2100 * Scl
  result.push(...header(X + gap,
    H,//- gap,
    Scl, headerOption))

  // Handle both old panel structure and new Simple SupplyPoint YC data
  if (panels.length > 0) {
    // Legacy panel structure
    panels.forEach((panel, t) => {
    const tableBranchCircuits = panel.branchCircuits // sp.branchCircuits.filter(branch => branch.masterNode_id === panel.id)
    const tableData = {
      panel: panel,
    }
    let rowCount = 7
    if (tableBranchCircuits.length - 1 > rowCount) {
      rowCount = tableBranchCircuits.length
    }
    result.push(...table(
      X + gap,                                // X position
      H - headerHeight - heightOfAllTables - gap,      // Y position
      Scl,
      tableOption,
      tableData))
    heightOfAllTables += (rowCount + 1) * rowHeight + gap
    })
  } else if (ycItems.length > 0) {
    // ✅ NEW SIMPLE SUPPLY POINT YC DATA STRUCTURE
 
    // Group YC items by housing/panel for table generation
    const groupedByHousing = ycItems.reduce((groups, item) => {
      const housing = item.housing || item.name || "General";
      if (!groups[housing]) {
        groups[housing] = [];
      }
      groups[housing].push(item);
      return groups;
    }, {});

    // Generate tables for each housing group
    Object.entries(groupedByHousing).forEach(([housing, items]) => {
      const tableData = {
        panel: {
          name: housing,
          id: housing.toLowerCase().replace(/\s+/g, '_')
        },
        branchCircuits: items.map(item => ({
          id: item.id,
          name: item.name,
          power: item.power,
          demandPower: item.demandPower,
          current: item.current,
          voltage: item.voltage,
          phaseCount: item.phaseCount,
          branchType: item.branchType
        }))
      };

      let rowCount = Math.max(7, items.length);

      result.push(...table(
        X + gap,
        H - headerHeight - heightOfAllTables - gap,
        Scl,
        tableOption,
        tableData
      ));

      heightOfAllTables += (rowCount + 1) * rowHeight + gap;
    });
  }

  result.push(...meterTableHeader(X + gap, H - heightOfAllTables - gap - headerHeight, Scl, headerOption))

  heightOfAllTables += (metersCount + 3) * rowHeight + 10 * Scl + gap
  result.push(...summary(X + gap, H - heightOfAllTables - gap - headerHeight, Scl, headerOption))
  heightOfAllTables += (5+k) * rowHeight + gap * 3

  result.push(Rectangle(X, H, yukCetWidth + 2 * gap, -heightOfAllTables - headerHeight - gap, tableOption)) // YÜKLEME CETVELİ ÇERÇEVESİ



  return { result: result, width: yukCetWidth+ 2 * gap, height: headerHeight + heightOfAllTables };
  function header(X, hY, Scl, option) {
    let result = []
    let X1 = X
    let textHeight = 20 * Scl

    let text = { text: "YÜKLEME CETVELİ", x: X1 + 750 * Scl, y: hY - 75 * Scl, textHeight: 55 * Scl }
    text.handle = generateStableId(text)
    result.push(Text(text.x, text.y, text, 0, option))
    result.push(Rectangle(X1, hY, 2100 * Scl, -260 * Scl, option))

    text = { text: "Tablolar", x: X1 + 230 * Scl, y: hY - 160 * Scl, textHeight: 40 * Scl }
    text.handle = generateStableId(text)
    result.push(Text(text.x, text.y, text, 0, option))
    result.push(Rectangle(X1, hY - 100 * Scl, 740 * Scl, -90 * Scl, option))

    X1 += 700 * Scl
    text = { text: "Linye", x: X1 + 50 * Scl, y: hY - 160 * Scl, textHeight: textHeight }
    text.handle = generateStableId(text)
    result.push(Text(text.x, text.y, text, 0, option))
    text = { text: "No", x: X1 + 50 * Scl, y: hY - 220 * Scl, textHeight: textHeight }
    text.handle = generateStableId(text)
    result.push(Text(text.x, text.y, text, 0, option))
    result.push(Rectangle(X1 + 40 * Scl, hY - 100 * Scl, 85 * Scl, -160 * Scl, option))
    X1 += 125 * Scl

    text = { text: "Sigorta", x: X1 + 20 * Scl, y: hY - 160 * Scl, textHeight: 40 * Scl }
    text.handle = generateStableId(text)
    result.push(Text(text.x, text.y, text, 0, option))
    result.push(Rectangle(X1, hY - 100 * Scl, 215 * Scl, -90 * Scl, option))
    X1 += 215 * Scl
    text = { text: "Sorti", x: X1 + 20 * Scl, y: hY - 160 * Scl, textHeight: 40 * Scl }
    text.handle = generateStableId(text)
    result.push(Text(text.x, text.y, text, 0, option))
    result.push(Rectangle(X1, hY - 100 * Scl, 170 * Scl, -90 * Scl, option))
    X1 += 170 * Scl
    text = { text: "Fazlar", x: X1 + 50 * Scl, y: hY - 160 * Scl, textHeight: 40 * Scl }
    text.handle = generateStableId(text)
    result.push(Text(text.x, text.y, text, 0, option))
    result.push(Rectangle(X1, hY - 100 * Scl, 440 * Scl, -90 * Scl, option))
    X1 += 440 * Scl
    text = { text: "Güç", x: X1 + 5 * Scl, y: hY - 200 * Scl, textHeight: 40 * Scl }
    text.handle = generateStableId(text)
    result.push(Text(text.x, text.y, text, 0, option))
    result.push(Rectangle(X1, hY - 100 * Scl, 130 * Scl, -160 * Scl, option))

    X1 += 130 * Scl
    text = { text: "Açıklamalar", x: X1 + 10 * Scl, y: hY - 200 * Scl, textHeight: 40 * Scl }
    text.handle = generateStableId(text)
    result.push(Text(text.x, text.y, text, 0, option))
    result.push(Rectangle(X1, hY - 100 * Scl, 320 * Scl, -160 * Scl, option))
    X1 = X
    text = { text: "Adı", x: X1 + 10 * Scl, y: hY - 240 * Scl, textHeight: textHeight }
    text.handle = generateStableId(text)
    result.push(Text(text.x, text.y, text, 0, option))
    result.push(Rectangle(X1, hY - 190 * Scl, 220 * Scl, -70 * Scl, option))

    X1 += 220 * Scl
    text = { text: "Şalt Özellikleri", x: X1 + 10 * Scl, y: hY - 240 * Scl, textHeight: textHeight }
    text.handle = generateStableId(text)
    result.push(Text(text.x, text.y, text, 0, option))
    result.push(Rectangle(X1, hY - 190 * Scl, 520 * Scl, -70 * Scl, option))

    X1 += 605 * Scl
    text = { text: "Io", x: X1 + 40 * Scl, y: hY - 240 * Scl, textHeight: textHeight }
    text.handle = generateStableId(text)
    result.push(Text(text.x, text.y, text, 0, option))
    text = { text: "Ith", x: X1 + 140 * Scl, y: hY - 240 * Scl, textHeight: textHeight }
    text.handle = generateStableId(text)
    result.push(Text(text.x, text.y, text, 0, option))

    result.push(Rectangle(X1, hY - 190 * Scl, 130 * Scl, -70 * Scl, option))

    X1 += 215 * Scl
    text = { text: "Ayd.", x: X1 + 10 * Scl, y: hY - 240 * Scl, textHeight: textHeight }
    text.handle = generateStableId(text)
    result.push(Text(text.x, text.y, text, 0, option))

    result.push(Rectangle(X1, hY - 190 * Scl, 85 * Scl, -70 * Scl, option))
    text = { text: "Priz", x: X1 + 90 * Scl, y: hY - 240 * Scl, textHeight: textHeight }
    text.handle = generateStableId(text)
    result.push(Text(text.x, text.y, text, 0, option))

    X1 += 170 * Scl
    text = { text: "L1", x: X1 + 10 * Scl, y: hY - 240 * Scl, textHeight: textHeight }
    text.handle = generateStableId(text)
    result.push(Text(text.x, text.y, text, 0, option))
    text = { text: "L2", x: X1 + 120 * Scl, y: hY - 240 * Scl, textHeight: textHeight }
    text.handle = generateStableId(text)
    result.push(Text(text.x, text.y, text, 0, option))

    result.push(Rectangle(X1, hY - 190 * Scl, 110 * Scl, -70 * Scl, option))
    X1 += 220 * Scl
    text = { text: "L3", x: X1 + 10 * Scl, y: hY - 240 * Scl, textHeight: textHeight }
    text.handle = generateStableId(text)
    result.push(Text(text.x, text.y, text, 0, option))
    text = { text: "L1.2.3", x: X1 + 113 * Scl, y: hY - 240 * Scl, textHeight: 25 * Scl }
    text.handle = generateStableId(text)
    result.push(Text(text.x, text.y, text, 0, option))

    result.push(Rectangle(X1, hY - 190 * Scl, 110 * Scl, -70 * Scl, option))

    return result
  }

  function meterTableHeader(X, hY, Scl, option) {
    let result = []
    let X1 = X
    let textHeight = 25 * Scl
    // data undefined olabiliyor (boş proje state'i). Yukarıdaki defensive
    // `panels` (line 44, `data?.panels || []`) yerine burada `data.panels`
    // erişimi yapılıyordu → runtime crash. Closure'daki `panels`'ı kullan.
    const meters = panels
    let c = meters.length + 1
    let y = hY - (c + 2) * rowHeight

    let text = { text: "Abone Listesi Şalt Özellikleri", x: X1 + 20 * Scl, y: hY - 40 * Scl, textHeight: 30 * Scl }
    text.handle = generateStableId(text)
    result.push(Text(text.x, text.y, text, 0, option))
    result.push(Rectangle(X1, hY, 2100 * Scl, -50 * Scl, option))

    result.push(Line(X1, hY - 50 * Scl, X1, y, option))
    text = { text: "Tablolar", x: X1 + 10 * Scl, y: hY - 90 * Scl, textHeight: textHeight }
    text.handle = generateStableId(text)
    result.push(Text(text.x, text.y, text, 0, option))

    X1 += 150 * Scl//-------135
    result.push(Line(X1, hY - 50 * Scl, X1, y, option))
    text = { text: "K.A.K.R.".toString(), x: X1 + 20 * Scl, y: hY - 90 * Scl, textHeight: textHeight }
    text.handle = generateStableId(text)
    result.push(Text(text.x, text.y, text, 0, option))

    X1 += 165 * Scl
    result.push(Line(X1, hY - 50 * Scl, X1, y, option))
    text = { text: "Say.Kes.".toString(), x: X1 + 5 * Scl, y: hY - 90 * Scl, textHeight: textHeight }
    text.handle = generateStableId(text)
    result.push(Text(text.x, text.y, text, 0, option))

    X1 += 150 * Scl
    result.push(Line(X1, hY - 50 * Scl, X1, y, option))
    text = { text: "DaireKes.".toString(), x: X1 + 5 * Scl, y: hY - 90 * Scl, textHeight: textHeight }
    text.handle = generateStableId(text)
    result.push(Text(text.x, text.y, text, 0, option))

    X1 += 150 * Scl
    result.push(Line(X1, hY - 50 * Scl, X1, y, option))
    text = { text: "A.Kap.".toString(), x: X1 + 5 * Scl, y: hY - 90 * Scl, textHeight: textHeight }
    text.handle = generateStableId(text)
    result.push(Text(text.x, text.y, text, 0, option))

    X1 += 100 * Scl
    text = { text: "Kablo".toString(), x: X1 + 5 * Scl, y: hY - 90 * Scl, textHeight: textHeight }
    text.handle = generateStableId(text)
    result.push(Text(text.x, text.y, text, 0, option))

    result.push(Line(X1, hY - 50 * Scl, X1, y, option))

    X1 += 215 * Scl//----------215
    result.push(Line(X1, hY - 50 * Scl, X1, y, option))
    text = { text: "Akım".toString(), x: X1 + 5 * Scl, y: hY - 90 * Scl, textHeight: textHeight }
    text.handle = generateStableId(text)
    result.push(Text(text.x, text.y, text, 0, option))

    X1 += 150 * Scl
    result.push(Line(X1, hY - 50 * Scl, X1, y, option))
    text = { text: "T.Güç".toString(), x: X1 + 5 * Scl, y: hY - 90 * Scl, textHeight: textHeight }
    text.handle = generateStableId(text)
    result.push(Text(text.x, text.y, text, 0, option))

    X1 += 130 * Scl
    result.push(Line(X1, hY - 50 * Scl, X1, y, option))
    text = { text: "Abone".toString(), x: X1 + 5 * Scl, y: hY - 90 * Scl, textHeight: textHeight }
    text.handle = generateStableId(text)
    result.push(Text(text.x, text.y, text, 0, option))

    X1 += 100 * Scl
    result.push(Line(X1, hY - 50 * Scl, X1, y, option))
    text = { text: "R".toString(), x: X1 + 5 * Scl, y: hY - 90 * Scl, textHeight: textHeight }
    text.handle = generateStableId(text)
    result.push(Text(text.x, text.y, text, 0, option))

    X1 += 90 * Scl
    result.push(Line(X1, hY - 50 * Scl, X1, y, option))
    text = { text: "S".toString(), x: X1 + 5 * Scl, y: hY - 90 * Scl, textHeight: textHeight }
    text.handle = generateStableId(text)
    result.push(Text(text.x, text.y, text, 0, option))


    X1 += 90 * Scl
    result.push(Line(X1, hY - 50 * Scl, X1, y, option))
    text = { text: "T".toString(), x: X1 + 5 * Scl, y: hY - 90 * Scl, textHeight: textHeight }
    text.handle = generateStableId(text)
    result.push(Text(text.x, text.y, text, 0, option))

    X1 += 90 * Scl
    result.push(Line(X1, hY - 50 * Scl, X1, y, option))
    text = { text: "RST".toString(), x: X1 + 5 * Scl, y: hY - 90 * Scl, textHeight: textHeight }
    text.handle = generateStableId(text)
    result.push(Text(text.x, text.y, text, 0, option))

    X1 += 90 * Scl
    result.push(Line(X1, hY - 50 * Scl, X1, y, option))
    text = { text: "Güç".toString(), x: X1 + 5 * Scl, y: hY - 90 * Scl, textHeight: textHeight }
    text.handle = generateStableId(text)
    result.push(Text(text.x, text.y, text, 0, option))

    X1 += 100 * Scl
    result.push(Line(X1, hY - 50 * Scl, X1, y, option))
    text = { text: "Açıklama".toString(), x: X1 + 5 * Scl, y: hY - 90 * Scl, textHeight: textHeight }
    text.handle = generateStableId(text)
    result.push(Text(text.x, text.y, text, 0, option))

    X1 += 330 * Scl
    result.push(Line(X1, hY - 50 * Scl, X1, y, option))
    hY -= 50 * Scl + rowHeight
    result.push(Line(X, hY, X1, hY, option))
    hY -= rowHeight
    textHeight = 22 * Scl

    meters.forEach((meter, m) => {
      // if(!meter.electrical.outs|| meter.electrical.outs.length===0)return
      let X2 = X



      result.push(Line(X2, hY - rowHeight * m, X1, hY - rowHeight * m, option))
      text = { text: meter.name, x: X2 + 5 * Scl, y: hY - rowHeight * m + 10 * Scl, textHeight: textHeight }
      text.handle = generateStableId(text)
      result.push(Text(text.x, text.y, text, 0, option))
      X2 += 150 * Scl
      text = { text: meter.rcd.title, x: X2 + 5 * Scl, y: hY - rowHeight * m + 10 * Scl, textHeight: textHeight }
      text.handle = generateStableId(text)
      result.push(Text(text.x, text.y, text, 0, option))
      X2 += 165 * Scl
      text = { text: meter.meterBreaker, x: X2 + 5 * Scl, y: hY - rowHeight * m + 10 * Scl, textHeight: textHeight }
      text.handle = generateStableId(text)
      result.push(Text(text.x, text.y, text, 0, option))

      X2 += 150 * Scl
      const mcb_title =  meter.panelMainBreaker.curve+"-"+meter.panelMainBreaker.polar+"x"+
        meter.panelMainBreaker.current.toString() + "A "       ;
      text = { text: mcb_title, x: X2 + 5 * Scl, y: hY - rowHeight * m + 10 * Scl, textHeight: textHeight }
      text.handle = generateStableId(text)
      result.push(Text(text.x, text.y, text, 0, option))
      X2 += 150 * Scl      
      text = { text: meter.cableCurrentLimit?.toString() + "A", x: X2 + 5 * Scl, y: hY - rowHeight * m + 10 * Scl, textHeight: textHeight }
      text.handle = generateStableId(text)
      result.push(Text(text.x, text.y, text, 0, option))
      X2 += 100 * Scl
      text = { text: meter.cableTitle, x: X2 + 5 * Scl, y: hY - rowHeight * m + 10 * Scl, textHeight: textHeight }
      text.handle = generateStableId(text)
      result.push(Text(text.x, text.y, text, 0, option))
      X2 += 215 * Scl
      text = { text: meter.current.toString() + "A", x: X2 + 5 * Scl, y: hY - rowHeight * m + 10 * Scl, textHeight: textHeight }
      text.handle = generateStableId(text)
      result.push(Text(text.x, text.y, text, 0, option))
      X2 += 150 * Scl
      text = { text: `${meter.demandPower} W`, x: X2 + 5 * Scl, y: hY - rowHeight * m + 10 * Scl, textHeight: textHeight }
      text.handle = generateStableId(text)
      result.push(Text(text.x, text.y, text, 0, option))
      X2 += 130 * Scl
      text = { text: `${meter.subscribeType}  `, x: X2 + 5 * Scl, y: hY - rowHeight * m + 10 * Scl, textHeight: textHeight }
      text.handle = generateStableId(text)
      result.push(Text(text.x, text.y, text, 0, option))

      X2 += 100 * Scl
      text = { text: `${meter.phases.r} `, x: X2 + 5 * Scl, y: hY - rowHeight * m + 10 * Scl, textHeight: textHeight }
      text.handle = generateStableId(text)
      result.push(Text(text.x, text.y, text, 0, option))

      X2 += 90 * Scl
      text = { text: `${meter.phases.s} `, x: X2 + 5 * Scl, y: hY - rowHeight * m + 10 * Scl, textHeight: textHeight }
      text.handle = generateStableId(text)
      result.push(Text(text.x, text.y, text, 0, option))

      X2 += 90 * Scl
      text = { text: `${meter.phases.t} `, x: X2 + 5 * Scl, y: hY - rowHeight * m + 10 * Scl, textHeight: textHeight }
      text.handle = generateStableId(text)
      result.push(Text(text.x, text.y, text, 0, option))

      X2 += 90 * Scl
      text = { text: `${meter.phases.rst} `, x: X2 + 5 * Scl, y: hY - rowHeight * m + 10 * Scl, textHeight: textHeight }
      text.handle = generateStableId(text)
      result.push(Text(text.x, text.y, text, 0, option))

      X2 += 90 * Scl
      text = { text: `${meter.installedPower} W`, x: X2 + 5 * Scl, y: hY - rowHeight * m + 10 * Scl, textHeight: textHeight }
      text.handle = generateStableId(text)
      result.push(Text(text.x, text.y, text, 0, option))

      X2 += 100 * Scl
      text = { text: `${meter.floorName}`, x: X2 + 5 * Scl, y: hY - rowHeight * m + 10 * Scl, textHeight: textHeight }
      text.handle = generateStableId(text)
      result.push(Text(text.x, text.y, text, 0, option))

      X2 += 325 * Scl

    })
    //------------------ TOPLAM SATIRI-----------------

    let X3 = X
    let hym = hY - (metersCount) * rowHeight
    X3 += 5 * Scl
    result.push(Line(X, hym, X1, hym, option))

    if (adpNode) {
      text = { text: `${adpNode.name}`, x: X3 + 5 * Scl, y: hym + 10 * Scl, textHeight: textHeight }
      text.handle = generateStableId(text)
      result.push(Text(text.x, text.y, text, 0, option))

      X3 += 150 * Scl

      text = { text: `${adpNode.rcd.title}`, x: X3 + 5 * Scl, y: hym + 10 * Scl, textHeight: textHeight }
      text.handle = generateStableId(text)
      result.push(Text(text.x, text.y, text, 0, option))
      X3 += 165 * Scl
      const meter_mcb_title =  adpNode.breaker.curve+"-"+
      (adpNode.breaker.polar===1?"":(adpNode.breaker.polar+"x"))+
      adpNode.breaker.current.toString() + "A "       ;
      text = { text: `${meter_mcb_title}`, x: X3 + 5 * Scl, y: hym + 10 * Scl, textHeight: textHeight }
      text.handle = generateStableId(text)
      result.push(Text(text.x, text.y, text, 0, option))

      X3 += 295 * Scl
      text = { text: `${adpNode.cableCurrentLimit} A`, x: X3 + 5 * Scl, y: hym + 10 * Scl, textHeight: textHeight }
      text.handle = generateStableId(text)
      result.push(Text(text.x, text.y, text, 0, option))

      X3 += 100 * Scl
      text = { text: `${adpNode.cableTitle}`, x: X3 + 5 * Scl, y: hym + 10 * Scl, textHeight: textHeight }
      text.handle = generateStableId(text)
      result.push(Text(text.x, text.y, text, 0, option))

      X3 += 215 * Scl
      text = { text: `${adpNode.current} A`, x: X3 + 5 * Scl, y: hym + 10 * Scl, textHeight: textHeight }
      text.handle = generateStableId(text)
      result.push(Text(text.x, text.y, text, 0, option))

      X3 += 150 * Scl
      text = { text: `${adpNode.demandPower} W`, x: X3 + 5 * Scl, y: hym + 10 * Scl, textHeight: textHeight }
      text.handle = generateStableId(text)
      result.push(Text(text.x, text.y, text, 0, option))



      X3 += 230 * Scl
      text = { text: `${adpNode.powers.phases.r}`, x: X3 + 5 * Scl, y: hym + 10 * Scl, textHeight: textHeight }
      text.handle = generateStableId(text)
      result.push(Text(text.x, text.y, text, 0, option))
      X3 += 90 * Scl
      text = { text: `${adpNode.powers.phases.s}`, x: X3 + 5 * Scl, y: hym + 10 * Scl, textHeight: textHeight }
      text.handle = generateStableId(text)
      result.push(Text(text.x, text.y, text, 0, option))
      X3 += 90 * Scl
      text = { text: `${adpNode.powers.phases.t}`, x: X3 + 5 * Scl, y: hym + 10 * Scl, textHeight: textHeight }
      text.handle = generateStableId(text)
      result.push(Text(text.x, text.y, text, 0, option))

      X3 += 90 * Scl
      text = { text: `${adpNode.powers.phases.rst}`, x: X3 + 5 * Scl, y: hym + 10 * Scl, textHeight: textHeight }
      text.handle = generateStableId(text)
      result.push(Text(text.x, text.y, text, 0, option))
      X3 += 90 * Scl
      text = { text: `${adpNode.installedTotalPower} W`, x: X3 + 5 * Scl, y: hym + 10 * Scl, textHeight: textHeight }
      text.handle = generateStableId(text)
      result.push(Text(text.x, text.y, text, 0, option))
      X3 += 105 * Scl
      text = { text: `TOPLAM`, x: X3 + 5 * Scl, y: hym + 10 * Scl, textHeight: textHeight }
      text.handle = generateStableId(text)
      result.push(Text(text.x, text.y, text, 0, option))
    }

    return result
  }

  function summary(X, hY, Scl, option) {

    let result = []
    let X1 = X
    let textHeight = 25 * Scl
    let y2 = hY - rowHeight * 4
  
    if (adpNode && adpNode.powers) {
      if (adpNode.powers.daireTotalPower) { y2 -= 1.5; k++ }
      if (adpNode.powers.isyeriTotalPower) { y2 -= 1.5; k++ }
      if (adpNode.powers.musterekTotalPower) { y2 -= 1.5; k++ }
      if (adpNode.powers.asansorTotalPower) { y2 -= 1.5; k++ }
    }

    let y = hY - (3 + k) * rowHeight * 1.5
    let X2 = X
    let text = { text: "Toplam Kurulu Güç ve Talep Güç Hesabı".toString(), x: X1 + 20 * Scl, y: hY - rowHeight * 1.2, textHeight: 30 * Scl }
    text.handle = generateStableId(text)
    result.push(Text(X1 + 20 * Scl, hY - rowHeight * 1.2, text, 0, option))
    result.push(Text(text.x, text.y, text, 0, option))

    result.push(Rectangle(X1, hY, 2100 * Scl, -rowHeight * 1.5, option))
    if (adpNode && adpNode.powers && adpNode.powers.daireTotalPower) {
      text = { text: "DAİRELER ".toString(), x: X1 + 10 * Scl, y: hY - rowHeight * 4, textHeight: textHeight }
      text.handle = generateStableId(text)
      result.push(Text(X1 + 10 * Scl, hY - rowHeight * 4, text, 0, option))
    }
    if (adpNode && adpNode.powers && adpNode.powers.musterekTotalPower) {
      text = { text: "GENEL TABLO".toString(), x: X1 + 10 * Scl, y: hY - rowHeight * 5.5, textHeight: textHeight }
      text.handle = generateStableId(text)
      result.push(Text(X1 + 10 * Scl, hY - rowHeight * 5.5, text, 0, option))
    }
    if (adpNode && adpNode.powers && adpNode.powers.isyeriTotalPower) {
      text = { text: "İŞ YERLERİ".toString(), x: X1 + 10 * Scl, y: hY - rowHeight * 7, textHeight: textHeight }
      text.handle = generateStableId(text)
      result.push(Text(X1 + 10 * Scl, hY - rowHeight * 7, text, 0, option))
    }
    if (adpNode && adpNode.powers && adpNode.powers.asansorTotalPower) {
      text = { text: "ASANSÖR ".toString(), x: X1 + 10 * Scl, y: hY - rowHeight * 8.5, textHeight: textHeight }
      text.handle = generateStableId(text)
      result.push(Text(X1 + 10 * Scl, hY - rowHeight * 8.5, text, 0, option))
    }
    text = { text: "TOPLAM ".toString(), x: X1 + 10 * Scl, y: y + 20 * Scl, textHeight: textHeight }
    text.handle = generateStableId(text)
    result.push(Text(X1 + 10 * Scl, y + 20 * Scl, text, 0, option))
    result.push(Line(X1, hY - rowHeight * 1.5, X1, y, option))

    X1 += 250 * Scl
    text = { text: "KURULU GÜÇ ".toString(), x: X1 + 10 * Scl, y: hY - rowHeight * 2.5, textHeight: textHeight }
    text.handle = generateStableId(text)
    result.push(Text(X1 + 10 * Scl, hY - rowHeight * 2.5, text, 0, option))
    if (adpNode && adpNode.powers && adpNode.powers.daireTotalPower) {
      text = { text: adpNode.powers.daireTotalPower, x: X1 + 10 * Scl, y: hY - rowHeight * 4, textHeight: textHeight }
      text.handle = generateStableId(text)
      result.push(Text(X1 + 10 * Scl, hY - rowHeight * 4, text, 0, option))

    }
    if (adpNode && adpNode.powers && adpNode.powers.musterekTotalPower) {
      text = { text: adpNode.powers.musterekTotalPower, x: X1 + 10 * Scl, y: hY - rowHeight * 5.5, textHeight: textHeight }
      text.handle = generateStableId(text)
      result.push(Text(X1 + 10 * Scl, hY - rowHeight * 5.5, text, 0, option))
    }
    if (adpNode && adpNode.powers && adpNode.powers.isyeriTotalPower) {
      text = { text: adpNode.powers.isyeriTotalPower, x: X1 + 10 * Scl, y: hY - rowHeight * 7, textHeight: textHeight }
      text.handle = generateStableId(text)
      result.push(Text(X1 + 10 * Scl, hY - rowHeight * 7, text, 0, option))
    }
    if (adpNode && adpNode.powers && adpNode.powers.asansorTotalPower) {
      text = { text: adpNode.powers.asansorTotalPower, x: X1 + 10 * Scl, y: hY - rowHeight * 8.5, textHeight: textHeight }
      text.handle = generateStableId(text)
      result.push(Text(X1 + 10 * Scl, hY - rowHeight * 8.5, text, 0, option))
    }
    if (adpNode && adpNode.installedTotalPower) {
      text = { text: adpNode.installedTotalPower + " W", x: X1 + 10 * Scl, y: y + 20 * Scl, textHeight: textHeight * 1.2 }
      text.handle = generateStableId(text)
      result.push(Text(X1 + 10 * Scl, y + 20 * Scl, text, 0, option))
    }
    result.push(Line(X1, hY - rowHeight * 1.5, X1, y, option))

    X1 += 250 * Scl
    text = { text: `TALEP FAK.`, x: X1 + 10 * Scl, y: hY - rowHeight * 2.5, textHeight: textHeight }
    text.handle = generateStableId(text)
    result.push(Text(X1 + 10 * Scl, hY - rowHeight * 2.5, text, 0, option))
    if (adpNode && adpNode.powers && adpNode.powers.daireDemandFakt) {
      text = { text: adpNode.powers.daireDemandFakt, x: X1 + 10 * Scl, y: hY - rowHeight * 4, textHeight: textHeight }
      text.handle = generateStableId(text)
      result.push(Text(X1 + 10 * Scl, hY - rowHeight * 4, text, 0, option))
    }
    if (adpNode && adpNode.powers && adpNode.powers.musterekDemandFakt) {
      text = { text: adpNode.powers.musterekDemandFakt, x: X1 + 10 * Scl, y: hY - rowHeight * 5.5, textHeight: textHeight }
      text.handle = generateStableId(text)
      result.push(Text(X1 + 10 * Scl, hY - rowHeight * 5.5, text, 0, option))
    }
    if (adpNode && adpNode.powers && adpNode.powers.isyeriDemandFakt) {
      text = { text: adpNode.powers.isyeriDemandFakt, x: X1 + 10 * Scl, y: hY - rowHeight * 7, textHeight: textHeight }
      text.handle = generateStableId(text)
      result.push(Text(X1 + 10 * Scl, hY - rowHeight * 7, text, 0, option))
    }
    if (adpNode && adpNode.powers && adpNode.powers.asansorDemandFakt) {
      text = { text: adpNode.powers.asansorDemandFakt, x: X1 + 10 * Scl, y: hY - rowHeight * 8.5, textHeight: textHeight }
      text.handle = generateStableId(text)
      result.push(Text(X1 + 10 * Scl, hY - rowHeight * 8.5, text, 0, option))
    }

    text = { text: " - - -  ".toString(), x: X1 + 10 * Scl, y: y + 20 * Scl, textHeight: textHeight * 1.2 }
    text.handle = generateStableId(text)
    result.push(Text(X1 + 10 * Scl, y + 20 * Scl, text, 0, option))

    result.push(Line(X1, hY - rowHeight * 1.5, X1, y, option))

    X1 += 250 * Scl
    text = { text: "TALEP GÜÇ".toString(), x: X1 + 10 * Scl, y: hY - rowHeight * 2.5, textHeight: textHeight }
    text.handle = generateStableId(text)
    result.push(Text(X1 + 10 * Scl, hY - rowHeight * 2.5, text, 0, option))
    if (adpNode && adpNode.powers && adpNode.powers.daireDemandPower) {
      text = { text: adpNode.powers.daireDemandPower, x: X1 + 10 * Scl, y: hY - rowHeight * 4, textHeight: textHeight }
      text.handle = generateStableId(text)
      result.push(Text(X1 + 10 * Scl, hY - rowHeight * 4, text, 0, option))
    }
    if (adpNode && adpNode.powers && adpNode.powers.musterekDemandPower) {
      text = { text: adpNode.powers.musterekDemandPower, x: X1 + 10 * Scl, y: hY - rowHeight * 5.5, textHeight: textHeight }
      text.handle = generateStableId(text)
      result.push(Text(X1 + 10 * Scl, hY - rowHeight * 5.5, text, 0, option))
    }
    if (adpNode && adpNode.powers && adpNode.powers.isyeriDemandPower) {
      text = { text: adpNode.powers.isyeriDemandPower, x: X1 + 10 * Scl, y: hY - rowHeight * 7, textHeight: textHeight }
      text.handle = generateStableId(text)
      result.push(Text(X1 + 10 * Scl, hY - rowHeight * 7, text, 0, option))
    }
    if (adpNode && adpNode.powers && adpNode.powers.asansorDemandPower) {
      text = { text: adpNode.powers.asansorDemandPower, x: X1 + 10 * Scl, y: hY - rowHeight * 8.5, textHeight: textHeight }
      text.handle = generateStableId(text)
      result.push(Text(X1 + 10 * Scl, hY - rowHeight * 8.5, text, 0, option))
    }
    if (adpNode && adpNode.demandPower) {
      text = { text: adpNode.demandPower + " W", x: X1 + 10 * Scl, y: y + 20 * Scl, textHeight: textHeight * 1.2 }
      text.handle = generateStableId(text)
      result.push(Text(X1 + 10 * Scl, y + 20 * Scl, text, 0, option))
    }
    result.push(Line(X1, hY - rowHeight * 1.5, X1, y, option))

    X1 += 250 * Scl
    if (adpNode && adpNode.current) {
      text = { text: `AKIM           : ${adpNode.current} A`, x: X1 + 10 * Scl, y: hY - rowHeight * 2.5, textHeight: textHeight }
      text.handle = generateStableId(text)
      result.push(Text(X1 + 10 * Scl, hY - rowHeight * 2.5, text, 0, option))
    }
    if (adpNode && adpNode.cableTitle) {

      text = { text: `ANA KOLON HATTI   : ${adpNode.cableTitle}    / AkımTK: ${adpNode.cableCurrentLimit} A`, x: X1 + 400 * Scl, y: hY - rowHeight * 2.5, textHeight: textHeight }
      text.handle = generateStableId(text)
      result.push(Text(X1 + 400 * Scl, hY - rowHeight * 2.5, text, 0, option))
    }



    if (adpNode && adpNode.breaker) {
            const meter_mcb_title =  adpNode.breaker.curve+"-"+adpNode.breaker.polar+"x"+
      adpNode.breaker.current.toString() + "A "       ;
      text = { text: `ANA KESİCİ : ${meter_mcb_title}`, x: X1 + 10 * Scl, y: hY - rowHeight * 4, textHeight: textHeight }
      text.handle = generateStableId(text)
      result.push(Text(X1 + 10 * Scl, hY - rowHeight * 4, text, 0, option))
    }
    if (adpNode && adpNode.rcd) {
      text = { text: `YANGIN KORUMA ŞALTERİ : ${adpNode.rcd.title}`, x: X1 + 400 * Scl, y: hY - rowHeight * 4, textHeight: textHeight }
      text.handle = generateStableId(text)
      result.push(Text(X1 + 400 * Scl, hY - rowHeight * 4, text, 0, option))
      result.push(Line(X1, hY - rowHeight * 1.5, X1, y, option))
    }
    X1 += 1100 * Scl
    result.push(Line(X1, hY - rowHeight * 1.5, X1, y, option))

    let yy = hY - rowHeight
    y = hY - rowHeight * 3
    if (adpNode && adpNode.powers && adpNode.powers.daireDemandFakt) {
      result.push(Line(X2, y, X1, y, option))
      y -= rowHeight * 1.5
    }
    if (adpNode && adpNode.powers && adpNode.powers.isyeriTotalPower) {
      result.push(Line(X2, y, X1, y, option))
      y -= rowHeight * 1.5
    }
    if (adpNode && adpNode.powers && adpNode.powers.musterekTotalPower) {
      result.push(Line(X2, y, X1, y, option))
      y -= rowHeight * 1.5
    }
    if (adpNode && adpNode.powers && adpNode.powers.asansorTotalPower) {
      result.push(Line(X2, y, X1, y, option))
      y -= rowHeight * 1.5
    }
    result.push(Line(X2, y, X1, y, option))
    y -= rowHeight * 1.5
    result.push(Line(X2, y, X1, y, option))

    return result
  }
  function table(X, hY, Scl, option, tableData) {
    const panel = tableData.panel


    const tableName = panel.name
    const installedPower = panel.installedPower
    const demandPower = panel.demandPower
    const demandFactor = panel.demandFactor
    let circuiteBreaker = ""
    let residualCurrentDevice = ""
    let cableTitle = ""
    let cableCurrentLimit = ""
    let current = (demandPower / 526).toFixed(2)
    let connection = {
      cableNo: 0,
      cableTitle: "",
      current: 0,
      to: "",
      equipmentNo: "",
      equipment: {
        Etiket: "",
        Akim: 0,
        polar: "",
        HavaAK: 0
      }
    }
    if (connection) {
      cableTitle = panel.cableTitle;
      cableCurrentLimit = panel.cableCurrentLimit;
      circuiteBreaker = panel.panelMainBreaker
      residualCurrentDevice = panel.rcd

    }
   const rawBC = panel?.branchCircuits ?? [];
const branchCircuits = Array.isArray(rawBC)
  ? rawBC
  : (rawBC && typeof rawBC === 'object' ? Object.values(rawBC) : []);
if (!Array.isArray(rawBC)) {
  console.warn("branchCircuits array değil, normalize edildi:", panel?.name, rawBC);
}

    let result = []
    let X1 = X
    const c1 = branchCircuits.length + 1
    let textHeight = 20 * Scl

    let c = 8
    if (c1 > 8) { c = c1 }
    let y = hY - (c) * rowHeight

    let text = { text: tableName, x: X1 + 20 * Scl, y: hY - 75 * Scl, textHeight: 40 * Scl }
    text.handle = generateStableId(text)
    result.push(Text(text.x, text.y, text, 0, option))

    result.push(Rectangle(X1, hY, 2100 * Scl, -c * rowHeight, option))
    X1 += 220 * Scl
    result.push(Line(X1, hY, X1, y, option))
    X1 += 520 * Scl
    result.push(Line(X1, hY, X1, y, option))
    X1 += 85 * Scl
    result.push(Line(X1, hY, X1, y, option))
    X1 += 130 * Scl
    result.push(Line(X1, hY, X1, y, option))
    X1 += 85 * Scl
    result.push(Line(X1, hY, X1, y, option))
    X1 += 85 * Scl
    result.push(Line(X1, hY, X1, y, option))
    X1 += 85 * Scl
    result.push(Line(X1, hY, X1, y, option))
    X1 += 110 * Scl
    result.push(Line(X1, hY, X1, y, option))
    X1 += 110 * Scl
    result.push(Line(X1, hY, X1, y, option))
    X1 += 110 * Scl
    result.push(Line(X1, hY, X1, y, option))
    X1 += 110 * Scl
    result.push(Line(X1, hY, X1, y, option))
    X1 += 130 * Scl
    result.push(Line(X1, hY, X1, y, option))
    X1 += 320 * Scl
    result.push(Line(X1, hY, X1, y, option))
    //-------------------------------------------
    X1 = X + 220 * Scl
    y = hY - rowHeight
    text = { text: "Kurulu Güç  :" + installedPower + " W", x: X1 + 10 * Scl, y: y + 10 * Scl, textHeight: textHeight, handFak: tableName }
    text.handle = generateStableId(text)
    result.push(Text(text.x, text.y, text, 0, option))

    result.push(Line(X1, y, X1 + 520 * Scl, y, option))
    y = hY - rowHeight * 2

    text = { text: "Talep Fak.  :" + demandFactor , x: X1 + 10 * Scl, y: y + 10 * Scl, textHeight: textHeight, handFak: tableName }
    text.handle = generateStableId(text)
    result.push(Text(text.x, text.y, text, 0, option))
    result.push(Line(X1, y, X1 + 520 * Scl, y, option))
    y = hY - rowHeight * 3

    text = { text: "Talep Güç  :" + demandPower + " W", x: X1 + 10 * Scl, y: y + 10 * Scl, textHeight: textHeight, handFak: tableName }
    text.handle = generateStableId(text)
    result.push(Text(text.x, text.y, text, 0, option))
    result.push(Line(X1, y, X1 + 520 * Scl, y, option))

    y = hY - rowHeight * 4
    text = { text: "Akım        :" + current + " A", x: X1 + 10 * Scl, y: y + 10 * Scl, textHeight: textHeight, handFak: tableName }
    text.handle = generateStableId(text)
    result.push(Text(text.x, text.y, text, 0, option))
    result.push(Line(X1, y, X1 + 520 * Scl, y, option))

    y = hY - rowHeight * 5
    text = { text: "Kesici      :" + circuiteBreaker.current+"A", x: X1 + 10 * Scl, y: y + 10 * Scl, textHeight: textHeight, handFak: tableName }
    text.handle = generateStableId(text)
    result.push(Text(text.x, text.y, text, 0, option))
    result.push(Line(X1, y, X1 + 520 * Scl, y, option))

    y = hY - rowHeight * 6
    text = { text: "K.A.K.R.    :" + residualCurrentDevice.title, x: X1 + 10 * Scl, y: y + 10 * Scl, textHeight: textHeight, handFak: tableName }
    text.handle = generateStableId(text)
    result.push(Text(text.x, text.y, text, 0, option))
    result.push(Line(X1, y, X1 + 520 * Scl, y, option))

    y = hY - rowHeight * 7
    text = {
      text: "İletken   :" + cableTitle +
        "   /" +
        (panel.cableCurrentCarryType === "earth"
          ? "Toprak ATK:"
          : panel.cableCurrentCarryType === "air"
            ? "Hava ATK:"
            : "Boru ATK:") +
        cableCurrentLimit + "A",
      x: X1 + 10 * Scl,
      y: y + 10 * Scl,
      textHeight: textHeight,
      handFak: tableName
    };

    text.handle = generateStableId(text)
    result.push(Text(text.x, text.y, text, 0, option))
    result.push(Line(X1, y, X1 + 520 * Scl, y, option))

    let tableRowY = hY
    X1 += 520 * Scl
    let plugSortiCount = 0
    let lightSortiCount = 0
    //--------------------------- TABLO ÇIKIŞLARI ----------------
    branchCircuits.forEach((element, i) => {
      if (!element) return; 
      const s = (v, fallback = "") => (v == null ? fallback : String(v)); // güvenli String
      let rowNo = i + 1
      tableRowY = hY - rowHeight * rowNo
      const currentMCB = element?.breaker 
      if (!element.phaseName) element.phaseName = "r"
      if (!element.sorti) element.sorti = 0
      if (!element.totalPower) element.totalPower = 0
      if (!element.description) element.description = ""
      if (element.type === "branchSocketMachine") {
        plugSortiCount++
      }

      if (element.type === "branchSocket") {
        plugSortiCount += element.sorti
      }
      if (element.type === "Light") {
        lightSortiCount += element.sorti
      }
      let textRow = { text: (rowNo).toString(), x: X1 + 10 * Scl, y: tableRowY + 15 * Scl, textHeight: textHeight }
      textRow.handle = generateStableId(textRow)
      result.push(Text(textRow.x, textRow.y, textRow, 0, option))

      result.push(Line(X1, tableRowY, X1 + 1360 * Scl, tableRowY, option))
      if (currentMCB) {
        let phaseText = currentMCB.curve+"-"
        if (element.phaseCount === 3) {
          if (element.notrSectionIsEqual) {
            phaseText = currentMCB.curve+"-4x"
          } else {
            phaseText = currentMCB.curve+"-3x"
          }
        } else {
          if (element.notrSectionIsEqual) {
            phaseText = currentMCB.curve+"-2x"
          }
        }
        textRow = { text: `${phaseText}${currentMCB.current} A`, x: X1 + 100 * Scl, y: tableRowY + 15 * Scl, textHeight: textHeight }
        textRow.handle = generateStableId(textRow)
        result.push(Text(textRow.x, textRow.y, textRow, 0, option))
      }
      if (currentMCB && currentMCB.shortCircuitCurCap) {

        textRow = { text: currentMCB.shortCircuitCurCap + "kA", x: X1 + 220 * Scl, y: tableRowY + 15 * Scl, textHeight: textHeight }
        textRow.handle = generateStableId(textRow)
        result.push(Text(textRow.x, textRow.y, textRow, 0, option))
      }
      let sortiLight = ""
      if (element.type === "light") {
        sortiLight = element.sorti
        textRow = { text: (sortiLight).toString(), x: X1 + 320 * Scl, y: tableRowY + 15 * Scl, textHeight: textHeight }
        textRow.handle = generateStableId(textRow)
        result.push(Text(textRow.x, textRow.y, textRow, 0, option))

      }
      let sortiSocket = ""
      if (
        element.type === "socketOven" ||
        element.type === "socketDish" ||
        element.type === "socketWash" ||
        element.type === "socket"
      ) {
        sortiSocket = element.sorti
        textRow = { text: sortiSocket.toString(), x: X1 + 410 * Scl, y: tableRowY + 15 * Scl, textHeight: textHeight }
        textRow.handle = generateStableId(textRow)
        result.push(Text(textRow.x, textRow.y, textRow, 0, option))

      }

      if (element.phaseName === "r") {
        textRow = { text: `${s(element.totalPower, "0")}`, x: X1 + 480 * Scl, y: tableRowY + 15 * Scl, textHeight: textHeight }
        textRow.handle = generateStableId(textRow)
        result.push(Text(textRow.x, textRow.y, textRow, 0, option))
      }

      if (element.phaseName === "s") {
        textRow = { text: `${element.totalPower}`, x: X1 + 600 * Scl, y: tableRowY + 15 * Scl, textHeight: textHeight }
        textRow.handle = generateStableId(textRow)
        result.push(Text(textRow.x, textRow.y, textRow, 0, option))
      }
      if (element.phaseName === "t") {
        textRow = { text: `${element.totalPower}`, x: X1 + 700 * Scl, y: tableRowY + 15 * Scl, textHeight: textHeight }
        textRow.handle = generateStableId(textRow)
        result.push(Text(textRow.x, textRow.y, textRow, 0, option))
      }
      if (element.phaseName === "rst") {
        textRow = { text: `${element.totalPower}`, x: X1 + 810 * Scl, y: tableRowY + 15 * Scl, textHeight: textHeight }
        textRow.handle = generateStableId(textRow)
        result.push(Text(textRow.x, textRow.y, textRow, 0, option))
      }
      textRow = { text: s(element.totalPower).toString(), x: X1 + 930 * Scl, y: tableRowY + 15 * Scl, textHeight: textHeight }
      textRow.handle = generateStableId(textRow)
      result.push(Text(textRow.x, textRow.y, textRow, 0, option))

      textRow = { text: s(element.description).toString(), x: X1 + 1060 * Scl, y: tableRowY + 15 * Scl, textHeight: textHeight }
      textRow.handle = generateStableId(textRow)
      result.push(Text(textRow.x, textRow.y, textRow, 0, option))


    });
    // ------------------- TOPLAMLAR -------------------

    let k = 8
    if (branchCircuits.length > 8) {
      k = branchCircuits.length + 1
    } else {
      result.push(Line(X1, hY - rowHeight * 7, X1 + 1360 * Scl, hY - rowHeight * 7, option))

    }
    tableRowY = hY - rowHeight * k


    let textRow = { text: `${lightSortiCount}`, x: X1 + 320 * Scl, y: tableRowY + 15 * Scl, textHeight: textHeight }
    textRow.handle = generateStableId(textRow)
    result.push(Text(textRow.x, textRow.y, textRow, 0, option))
    textRow = { text: `${plugSortiCount}`, x: X1 + 410 * Scl, y: tableRowY + 15 * Scl, textHeight: textHeight }
    textRow.handle = generateStableId(textRow)
    result.push(Text(textRow.x, textRow.y, textRow, 0, option))

    if (panel && panel.phases) {
      textRow = { text: `${panel.phases.r}`, x: X1 + 480 * Scl, y: tableRowY + 15 * Scl, textHeight: textHeight }
      textRow.handle = generateStableId(textRow)
      result.push(Text(textRow.x, textRow.y, textRow, 0, option))
      textRow = { text: `${panel.phases.s}`, x: X1 + 590 * Scl, y: tableRowY + 15 * Scl, textHeight: textHeight }
      textRow.handle = generateStableId(textRow)
      result.push(Text(textRow.x, textRow.y, textRow, 0, option))

      textRow = { text: `${panel.phases.t}`, x: X1 + 700 * Scl, y: tableRowY + 15 * Scl, textHeight: textHeight }
      textRow.handle = generateStableId(textRow)
      result.push(Text(textRow.x, textRow.y, textRow, 0, option))

      textRow = { text: `${panel.phases.rst}`, x: X1 + 810 * Scl, y: tableRowY + 15 * Scl, textHeight: textHeight }
      textRow.handle = generateStableId(textRow)
      result.push(Text(textRow.x, textRow.y, textRow, 0, option))
    }

    textRow = { text: `${panel.installedPower}`, x: X1 + 930 * Scl, y: tableRowY + 15 * Scl, textHeight: textHeight }
    textRow.handle = generateStableId(textRow)
    result.push(Text(textRow.x, textRow.y, textRow, 0, option))
    textRow = { text: "TOPLAM", x: X1 + 1060 * Scl, y: tableRowY + 15 * Scl, textHeight: textHeight }
    textRow.handle = generateStableId(textRow)
    result.push(Text(textRow.x, textRow.y, textRow, 0, option))

    return result
  }





};

function generateStableId(element) {
  let faktor = "0"
  if (element.handFak) { faktor = element.handFak }
  return `text-${element.text}-${element.x}-${element.y}-${element.textHeight}-${faktor}`;
}












